import { Box, Container, Stack, Typography } from "@mui/material";

import { useStore, observer } from "../../../service/mobx";
import { Section } from "../index";
import { Input } from "../Main";
import ButtonText from "../../../component/Button/Text";

function CTA() {
  const { agent, bottomNav, device } = useStore();

  return (
    <Section display="flex" flexDirection="column" justifyContent="center">
      <Container my="auto" maxWidth="expanded">
        <Typography
          pb={{ compact: 4, expanded: 7 }}
          component="div"
          align="center"
          variant="displayLg"
          color="dark.surface.on.color"
          height="100%"
          sx={{
            textWrap: "balance",
            typography: { compact: "headlineLg", expanded: "displayLg" }
          }}
        >
          See for yourself
        </Typography>
        <Input />
      </Container>
      <Container maxWidth="large">
        <Stack
          useFlexGap
          pt={{ compact: 7, expanded: 4 }}
          spacing={2}
          direction="row"
          flexWrap={{ compact: "wrap", expanded: "nowrap" }}
        >
          {[
            "Which papers are trending?",
            "What's the difference between diffusion models and GANs?",
            "Show me CVPR papers on self-driving cars"
          ].map(question => (
            <Subheader
              key={question}
              text={question}
              onClick={() => {
                agent.chat(question);

                if (device.isPhone) {
                  bottomNav.actions[1].onClick();
                }
              }}
            />
          ))}
        </Stack>
      </Container>
    </Section>
  );
}
export default observer(CTA);
const Subheader = ({ text, onClick, IconEnd }) => (
  <Box width="100%">
    <ButtonText
      label={text}
      href="/"
      onClick={onClick}
      IconEnd={IconEnd}
      sx={{
        width: "100%",
        p: 3,
        typography: {
          compact: "titleSm",
          expanded: "titleMd"
        },
        textWrap: "balance",
        height: { compact: 56, expanded: 72 },
        borderRadius: theme => theme.shape.md.round,
        color: "dark.surface.on.color",
        bgcolor: "dark.surface.container.low",
        "&:hover": {
          cursor: "pointer",
          color: "dark.secondary.on.container",
          bgcolor: "dark.secondary.container"
        }
      }}
    />
  </Box>
);
